import { combineReducers } from "redux";
import { reducer as autoboardingReducer } from "./slices/autoboardingSlice.js";
import { reducer as glimmerReducer } from "./slices/glimmerSlice.js";

export const reducer = combineReducers({
  autoboarding: autoboardingReducer,
  glimmer: glimmerReducer,
});
